var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"id":"global-layout-icon-logout"},on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-sign-out"})])
}
var staticRenderFns = []

export { render, staticRenderFns }